import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"
import { Observable } from "rxjs"
import { APIResponse } from "fakturnia-shared"

export type TwoFactorMethod = 'authenticator' | 'email';

export interface TwoFactorStatus {
    enabled: boolean;
    method: TwoFactorMethod | null;
}

export interface SetupAuthenticatorResponse {
    method: 'authenticator';
    secret: string;
    qrCode: string;
    uri: string;
}

export interface SetupEmailResponse {
    method: 'email';
    codeSent: boolean;
}

export interface VerifyResponse {
    enabled: boolean;
    recoveryKeys: string[];
}

@Injectable({
    providedIn: 'root'
})
export class TwoFactorApiService {

    constructor(private http: HttpClient) { }

    /**
     * Pobiera status weryfikacji dwuetapowej
     */
    public getStatus(): Observable<APIResponse> {
        return this.http.get<APIResponse>(API_HOST + 'settings/two-factor');
    }

    /**
     * Inicjuje konfigurację 2FA dla authenticatora
     */
    public setupAuthenticator(): Observable<APIResponse> {
        return this.http.post<APIResponse>(API_HOST + 'settings/two-factor/setup', { 
            method: 'authenticator' 
        });
    }

    /**
     * Inicjuje konfigurację 2FA dla email
     */
    public setupEmail(): Observable<APIResponse> {
        return this.http.post<APIResponse>(API_HOST + 'settings/two-factor/setup', { 
            method: 'email' 
        });
    }

    /**
     * Weryfikuje kod i aktywuje 2FA
     */
    public verify(code: string): Observable<APIResponse> {
        return this.http.post<APIResponse>(API_HOST + 'settings/two-factor/verify', { 
            code 
        });
    }

    /**
     * Wyłącza 2FA (wymaga hasła)
     */
    public disable(password: string): Observable<APIResponse> {
        return this.http.post<APIResponse>(API_HOST + 'settings/two-factor/disable', { 
            password 
        });
    }

    /**
     * Weryfikuje kod 2FA podczas logowania
     */
    public verifyLogin(tempToken: string, code: string, deviceInfo?: { 
        browser?: string; 
        deviceName?: string; 
        platform?: string; 
    }): Observable<APIResponse> {
        return this.http.post<APIResponse>(API_HOST + 'auth/verify-2fa', { 
            tempToken, 
            code,
            ...deviceInfo
        });
    }

    /**
     * Wysyła ponownie kod email podczas 2FA logowania
     */
    public resendLoginEmail(tempToken: string): Observable<APIResponse> {
        return this.http.post<APIResponse>(API_HOST + 'auth/resend-2fa-email', { 
            tempToken 
        });
    }
}
